'use client'
import { FC, useState, useEffect} from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText} from "@prismicio/react";
import { RoadmapTable, RoadmapCalender } from "@/components"
import { createClient } from '@/prismicio';
/**
 *  for `ProjectRoadMap`.
 */
export type ProjectRoadmap =
  SliceComponentProps<Content.ProjectRoadmapSlice>;

/**
 * Component for "ProjectRoadMap" Slices.
 */
const ProjectRoadMap: FC<ProjectRoadmap> = ({ slice }) => {

  const [roadmap, setRoadmap] = useState([]);
    
    useEffect(()=>{
  
      const client = createClient();
  
      const getCalender = async () => {
        const roadmapData = await client.getAllByType('roadmap_category')as any
        roadmapData ? setRoadmap(roadmapData) : [];
      }
  
      getCalender();
  
    },[])

  return (
    <>
      <section
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
        className="font-fellix px-4 md:px-8 lg:px-12"
      >
        <article className='text-center max-w-[800px] mx-auto block mt-16'>
          <PrismicRichText field={slice.primary.title}/>
        </article>
        <article className='text-center text-[28px] leading-[34px] mt-4 max-w-[800px] mx-auto block mb-16'>
          <PrismicRichText field={slice.primary.description}/>
        </article>
      </section>
      <section className="font-fellix pl-4 md:pl-8 lg:pl-12 w-full bg-roadmapgrey" data-component-="RoadMapTable">
            {slice.primary.display_table === true ? <RoadmapTable data={roadmap} info={slice}/> : <></>} 
      </section>
      <section className="font-fellix pl-4 md:pl-8 lg:pl-12 w-full pt-16"  data-component-="RoadmapCalender">
            {slice.primary.display_calender === true ? <RoadmapCalender data={roadmap} /> : <></>}
      </section>
    </>
  );
};

export default ProjectRoadMap;
